import script from "./help_page.vue?vue&type=script&setup=true&lang=js"
export * from "./help_page.vue?vue&type=script&setup=true&lang=js"

import "./help_page.vue?vue&type=style&index=0&id=33436c7d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33436c7d"]])

export default __exports__